import {observable} from 'mobx';
import {createInstance, ModelProperties} from 'utils';

import {WebPage} from './web-page';
import {WebLocaleCategory} from './web-locale-category';

export class WebPageCategory {
    @observable pageId!: number;

    @observable categoryId!: number;

    @observable primary!: boolean;

    @observable page?: WebPage;

    @observable category?: WebLocaleCategory;

    constructor(pageCategory?: ModelProperties<WebPageCategory>) {
        if (pageCategory) {
            Object.assign(this, pageCategory);
            this.page = createInstance(WebPage, pageCategory.page);
            this.category = createInstance(WebLocaleCategory, pageCategory.category);
        }
    }
}